var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { setBackground, previewBackground } from './actions';
import { reduxKey } from './constants';
var actionHandlers = handleActions((_a = {},
    _a[setBackground.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, deviationId = _c.deviationId, backgroundId = _c.backgroundId;
        return (__assign(__assign({}, state), (_b = {}, _b[deviationId] = { backgroundId: backgroundId }, _b)));
    },
    _a[previewBackground.toString()] = function (state, _a) {
        var backgroundId = _a.payload.backgroundId;
        return (__assign(__assign({}, state), { backgroundPreview: backgroundId }));
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map